import React from "react";
import * as XLSX from "xlsx";

export default function SearchReports({
  onSearch,
  onFromDate,
  onToDate,
  fromDate,
  toDate,
  reports,
  aggregators = [],
  onAggregatorChange,
  aggregator,
}) {
  const handleExport = () => {
    if (reports.length === 0) {
      alert("No data to export!");
      return;
    }

    // Calculate totals
    const totalSubTotal = reports.reduce(
      (acc, r) => acc + (parseFloat(r.subTotal) || 0),
      0
    );
    const totalAmount = reports.reduce(
      (acc, r) => acc + (parseFloat(r.totalAmount) || 0),
      0
    );

    // Convert report list to sheet
    const wsData = [...reports];

    // ✅ Add empty spacer row
    wsData.push({});

    // ✅ Add Total row
    wsData.push({
      aggregator: "TOTAL",
      subTotal: totalSubTotal,
      totalAmount: totalAmount,
    });

    const ws = XLSX.utils.json_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reports");

    const fileName = `${fromDate || "all"}_${toDate || "all"}_reports.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  return (
    <div className="search-controls d-flex gap-2 searchreport">
      <p>From:</p>
      <input
        type="date"
        value={fromDate}
        onChange={(e) => onFromDate(e.target.value)}
        className="search-bar"
      />
      <p>To:</p>
      <input
        type="date"
        value={toDate}
        onChange={(e) => onToDate(e.target.value)}
        className="search-bar"
      />
      <input
        type="text"
        placeholder="Search..."
        className="search-bar"
        onChange={(e) => onSearch(e.target.value)}
      />
      <div>
        <select
          id="aggregatorFilter"
          className="search-bar"
          value={aggregator || ""}
          onChange={(e) => onAggregatorChange(e.target.value)}
        >
          <option value="">All Aggregators</option>
          {aggregators.map((agg) => (
            <option key={agg} value={agg}>
              {agg}
            </option>
          ))}
        </select>
      </div>
      <button className="btn btn-primary" onClick={handleExport}>
        Export
      </button>
    </div>
  );
}
